export const state = () => ({});

export const mutations = {};

export const actions = {
    async signup(context, payload) {
        try {
            return await this.$adminApi.post("/newsletter", { email: payload.email, list: payload.list, recaptcha: payload.recaptcha });
        } catch (error) {
            console.log("Failed to signup: " + error);
            throw error;
        }
    },
};

export const getters = {};
